import dataService from 'services/data';
import { startLoader, stopLoader } from './loader';

export const UPDATE_CLIENT = '@transaction/update-client';
export const UPDATE_VEHICLE = '@transaction/update-vehicle';
export const UPDATE_EXTRA = '@transaction/update-extra';
export const NEW_TRANSACTION = '@transaction/new-transaction';
export const SET_FORM_FIELDS = '@transaction/set-form-fields';
export const SET_FORM_FIELDS_ERROR = '@transaction/set-form-fields-error';

export const saveClient = (items: any) => {
  return (dispatch: any) => {
    dispatch({
      type: UPDATE_CLIENT,
      payload: items
    });
  };
};
export const saveVehicle = (items: any) => {
  return (dispatch: any) => {
    dispatch({
      type: UPDATE_VEHICLE,
      payload: items
    });
  };
};
export const saveExtra = (items: any) => {
  return (dispatch: any) => {
    dispatch({
      type: UPDATE_EXTRA,
      payload: items
    });
  };
};
export const updateFormFields = (items: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_FORM_FIELDS,
      payload: items
    });
  };
};
export const newTransaction = () => {
  return async (dispatch: any) => {
    try {
      dispatch(startLoader());
      let result = await dataService.getCompanyData();
      dispatch({
        type: NEW_TRANSACTION,
        payload: result
      });
      dispatch(stopLoader());
    } catch (error) {
      dispatch(stopLoader());
      // dispatch({ type: SET_FORM_FIELDS_ERROR });
      // throw error;
    }
  };
};
